import { type ChatRoom, isGroupChatroom } from 'models';
import { ChatGroupHeader } from './chat-group-header';
import { ChatUserHeader } from './chat-user-header';

type P = {
  chatroom: ChatRoom;
  onChatDeleted: () => Promise<void>;
};

const ChatHeader = ({ chatroom, onChatDeleted }: P) => {
  if (isGroupChatroom({ chatroom })) {
    return <ChatGroupHeader chatroom={chatroom} onChatDeleted={onChatDeleted} />;
  }

  return <ChatUserHeader chatroom={chatroom} onChatDeleted={onChatDeleted} />;
};

export default ChatHeader;
